import { WidgetDetails } from 'services/ApiService/ServiceBoard/ServiceBoardApiClient';
import { ApiRequest, Reducer } from 'store/store';
import { initialApiRequest } from 'store/store-tools';

export const initialState: {
    addPersonWidget: ApiRequest,
    deletePersonWidget: ApiRequest,
    autoSubscribe: ApiRequest,
    myWidgetDetails: ApiRequest<WidgetDetails[]>,
} = {
    addPersonWidget: initialApiRequest(),
    deletePersonWidget: initialApiRequest(),
    autoSubscribe: initialApiRequest(),
    myWidgetDetails: initialApiRequest(),
} as const;

export type WidgetState = typeof initialState;

export const WidgetReducer: Reducer<WidgetState> = (state = initialState, action) => {
    switch (action.type) {
        case '@WIDGET/ADD_PERSON_WIDGETS_FETCH_REQUEST':
            return {
                ...state,
                addPersonWidget: {
                    ...state.addPersonWidget,
                    state: 'isFetching',
                },
            } satisfies WidgetState;
        case '@WIDGET/ADD_PERSON_WIDGETS_FETCH_SUCESS':
            return {
                ...state,
                addPersonWidget: {
                    ...state.addPersonWidget,
                    state: 'valid',
                },
                myWidgetDetails: {
                    ...state.myWidgetDetails,
                    state: 'outdated',
                },
            } satisfies WidgetState;
        case '@WIDGET/ADD_PERSON_WIDGETS_FETCH_FAILURE':
            return {
                ...state,
                addPersonWidget: {
                    ...state.addPersonWidget,
                    state: 'error',
                },
            } satisfies WidgetState;

        case '@WIDGET/DELETE_PERSON_WIDGETS_FETCH_REQUEST':
            return {
                ...state,
                deletePersonWidget: {
                    ...state.deletePersonWidget,
                    state: 'isFetching',
                },
            } satisfies WidgetState;
        case '@WIDGET/DELETE_PERSON_WIDGETS_FETCH_SUCESS':
            return {
                ...state,
                deletePersonWidget: {
                    ...state.deletePersonWidget,
                    state: 'valid',
                },
                myWidgetDetails: {
                    ...state.myWidgetDetails,
                    state: 'outdated',
                },
            } satisfies WidgetState;
        case '@WIDGET/DELETE_PERSON_WIDGETS_FETCH_FAILURE':
            return {
                ...state,
                deletePersonWidget: {
                    ...state.deletePersonWidget,
                    state: 'error',
                },
            } satisfies WidgetState;

        case '@WIDGET/AUTO_SUBSCRIBE_FETCH_REQUEST':
            return {
                ...state,
                autoSubscribe: {
                    ...state.autoSubscribe,
                    state: 'isFetching',
                },
            } satisfies WidgetState;
        case '@WIDGET/AUTO_SUBSCRIBE_FETCH_SUCCESS':
            return {
                ...state,
                autoSubscribe: {
                    ...state.autoSubscribe,
                    state: 'valid',
                },
                myWidgetDetails: {
                    ...state.myWidgetDetails,
                    state: 'outdated',
                },
            } satisfies WidgetState;
        case '@WIDGET/AUTO_SUBSCRIBE_FETCH_FAILURE':
            return {
                ...state,
                autoSubscribe: {
                    ...state.autoSubscribe,
                    state: 'error',
                },
            } satisfies WidgetState;
        case '@WIDGET/MY_WIDGET_DETAILS_FETCH_REQUEST':
            return {
                ...state,
                myWidgetDetails: {
                    ...state.myWidgetDetails,
                    state: 'isFetching',
                },
            } satisfies WidgetState;
        case '@WIDGET/MY_WIDGET_DETAILS_FETCH_SUCCESS':
            return {
                ...state,
                myWidgetDetails: {
                    ...state.myWidgetDetails,
                    state: 'valid',
                    data: action.payload,
                },
            } satisfies WidgetState;
        case '@WIDGET/MY_WIDGET_DETAILS_FETCH_FAILURE':
            return {
                ...state,
                myWidgetDetails: {
                    ...state.myWidgetDetails,
                    state: 'error',
                },
            } satisfies WidgetState;

        default:
            return state;
    }
};